import React from "react";
import checkmark from "../../images/checkmark.png"
import {useNavigate} from "react-router-dom";

export default function Confirmation() {
    const navigate = useNavigate();
    return (
        <div className="basicContainer">
            <div className="successContainer">
                <h1 className="title">Tu Orden Fue Enviada</h1>
                <div className="image">
                    <img src={checkmark} alt="checkmark" className="checkmark"/>
                </div>
                <div>
                    <button className="newOrderButton" onClick={ () => {navigate("/")}}>
                        Nueva Orden
                    </button>
                </div>

            </div>

        </div>
    );
}
